import React from "react";
import styles from "./Card2.module.scss";

const Card2 = () => {
  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>
            New password<span>*</span>
          </label>
          <input type="password" />
        </div>
        <div className={styles.field}>
          <label>
            Confirm password<span>*</span>
          </label>
          <input type="password" />
        </div>
        <button type="button">Update changes</button>
      </form>
    </div>
  );
};

export default Card2;
